import styled, { css } from 'styled-components'
import { theme, media } from '../../../styles/_variables'

export const Title = styled.div`
  background-color: ${theme.color.primaryColor};
  padding: 8px 24px;
  ${media.tablet`
    padding: 8px 16px;
  `}
`

export const TextRowWrapper = styled.div`
  display: ${props => (props.display ? props.display : 'flex')};
  justify-content: space-between;
  padding: 4px 0;
  ${props => props.margin && css`
    margin: ${props.margin};
  `}
      
  ${props => (props.type === 'detail' || props.type === 'detail-technique'
    ? css`
      > div {
        margin: 8px 16px 0 24px;
        ${media.mobileXL`
          margin: 0px 8px;
        `}
        ${media.tablet`
          margin: 0px 16px;
        `}
        &:first-child {
          margin-right: 0;
          flex-basis: 50%;
        }
        &:last-child {
          > h4 {
            max-width: 80%;
          }
        }
      }
    `
    : css`
      > div {
        &:first-child {
          margin: 0 16px 0 24px;
          ${media.tablet`
            margin: 0 8px 0 16px;
            flex-basis: 45%;
          `}
        }
        &:last-child {
          margin: 0 40px 0 16px;
          ${media.tablet`
            margin: 0 16px 0 8px;
            flex-basis: 50%;
          `}
        }
      }
    `
  )}    
  > div {
    &:last-child {
      > h4 {
        max-width: 50%;
        ${props => props.type === 'detail-technique' && css`
          max-width: 100%;
          text-align: right;
        `}
        ${media.tablet`
          max-width: 100%;
          text-align: right;
        `}  
      }
    }
  }
  ${props => props.isSummaryInProfile && css`
    ${(props.type === 'detail' || props.type === 'detail-technique')
    ? css`
      > div {
        margin: 8px 16px 0 24px;
        ${media.tablet`
          margin: 0px 16px;
        `}
        ${media.mobileXL`
          margin: 0px 8px;
        `}
        &:first-child {
          margin-right: 0;
          flex-basis: 50%;
        }
        &:last-child {
          > h4 {
            max-width: 80%;
          }
        }
      }
    `
    : css`
      > div {
        &:first-child {
          flex-basis: 50%;
          margin: 0 16px 0 24px;
          ${media.tablet`
            margin: 0 16px 0 16px;
          `}
          ${media.mobileXL`
            flex-basis: 50%;
            margin: 0 8px 0 8px;
          `}
        }
        &:last-child {
          flex-basis: 50%;
          ${media.mobileXL`
            flex-basis: 50%;
          `}
          ${media.mobileL`
            flex-basis: 50%;
            margin: 0 8px 0 8px;
          `}
          margin: ${(props.type !== 'detail' || props.type !== 'detail-technique') && '0 24px 0 16px'};
          > h4 {
            max-width: 80%;
          }
        }
      } 
    `
}
  `}
`

export const SummaryBoxWrapper = styled.div`
  ${media.tablet`
    margin: 0 0px;
  `}
  ${props => props.isSummaryInProfile && css`
    ${Title} {
      padding: 8px 24px;
      h4 {
        font-size: ${theme.fonts.size.extraNormal};
      }
    }
  `}
`

export const Link = styled.a`
  color: ${theme.color.primaryColor};
  > p {
    color: ${theme.color.primaryColor};
  }
  &:hover {
    > p {
      color: ${theme.color.primaryColor};
    }
  }
`

export default Title



// WEBPACK FOOTER //
// ./src/components/common/summary-detail/styled.js